var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    clipPath: "url(#clip0_9551_52508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.16602 12.4974H3.33268C2.89065 12.4974 2.46673 12.3218 2.15417 12.0092C1.84161 11.6967 1.66602 11.2728 1.66602 10.8307V3.33073C1.66602 2.8887 1.84161 2.46478 2.15417 2.15222C2.46673 1.83966 2.89065 1.66406 3.33268 1.66406H10.8327C11.2747 1.66406 11.6986 1.83966 12.0112 2.15222C12.3238 2.46478 12.4993 2.8887 12.4993 3.33073V4.16406M9.16602 7.4974H16.666C17.5865 7.4974 18.3327 8.24359 18.3327 9.16406V16.6641C18.3327 17.5845 17.5865 18.3307 16.666 18.3307H9.16602C8.24554 18.3307 7.49935 17.5845 7.49935 16.6641V9.16406C7.49935 8.24359 8.24554 7.4974 9.16602 7.4974Z",
    stroke: "#172B4D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9551_52508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c9173c9444e6e4a17fa1c37f771f91f1.svg";
export { ForwardRef as ReactComponent };